import { useEffect, useState } from 'react'
import { useSetting } from './useSetting'
import { OPENING_CUTOFF_KEY, isPastCutoffET } from '../lib/marketHours'

export interface OpeningCutoffStatus {
  /** Configured "HH:MM" ET cutoff, or null when the feature is off. */
  time: string | null
  /** True when a cutoff is set and the current ET wall clock is at or past it. */
  active: boolean
  /** Short clause for tooltips/banners, e.g. "After cutoff (14:00 ET)". Null when inactive. */
  reason: string | null
}

/**
 * After the configured ET wall-clock time, opening trades (BUY) are blocked
 * for the rest of the day; closes remain allowed. Re-evaluates every 30s so
 * the cutoff trips without requiring a refresh.
 */
export function useOpeningCutoff(): OpeningCutoffStatus {
  const [time] = useSetting<string | null>(OPENING_CUTOFF_KEY, null)
  const [active, setActive] = useState<boolean>(() => isPastCutoffET(time))

  useEffect(() => {
    setActive(isPastCutoffET(time))
    if (!time) return
    const id = window.setInterval(() => setActive(isPastCutoffET(time)), 30_000)
    return () => window.clearInterval(id)
  }, [time])

  const reason = active && time ? `After cutoff (${time} ET)` : null
  return { time, active, reason }
}
